import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const { data } = await api.post('/auth/google/session', { session_id: sessionId });
        setUser(data);
        // Clean URL fragment then go to dashboard
        window.history.replaceState({}, '', window.location.pathname);
        navigate('/dashboard', { replace: true, state: { user: data } });
      } catch {
        navigate('/login?error=google_failed', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="auth-loading" data-testid="google-callback-loading">
      <div className="auth-spinner" />
      <p>Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
